import { BRAND, CURRENCY, GAEVENT } from './AnalyticsConstants';

export interface itemInfoEvent {
  item_id: string;
  item_name: string;
  affiliation: string | number;
  coupon: string | number;
  discount: number;
  index: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_category5: string;
  item_list_id: string;
  item_list_name: string;
  item_variant: string;
  location_id: string | number;
  price: number;
  quantity: number;
  promotion_id: string;
}

export interface ecomAddCartInfo {
  currency: string;
  value: string | number;
  items: itemInfoEvent[];
}

export const getItemData = (item: any, data?: any): itemInfoEvent => {
  const { itemCategory, location } = data;
  const discount = item?.prices?.[0]?.priceAlteration?.[0]?.value ?? 0;
  const basePrice = item?.prices?.[0]?.value ?? 0;
  const itemData: itemInfoEvent = {
    item_id: item?.id ?? '',
    item_name: item?.id ?? '',
    affiliation: item?.promotionInfo?.[0]?.campaignId ?? '',
    coupon: '',
    discount: discount && Number(discount),
    index: 0,
    item_brand: BRAND,
    item_category: itemCategory?.productName ?? itemCategory?.id ?? 'MOBILE',
    item_category2: itemCategory ? 'BUNDLE' : 'MOBILE',
    item_category3: '',
    item_category4: '',
    item_category5: '',
    item_list_id: itemCategory ? 'Fixnet' : 'Mobile',
    item_list_name: itemCategory ? 'Fixnet' : 'Mobile',
    item_variant: itemCategory?.productName ?? itemCategory?.id ?? item?.id,
    location_id: location,
    price: basePrice && Number(basePrice),
    quantity: 1,
    promotion_id: item?.promotionInfo?.[0]?.campaignId ?? ''
  };
  return itemData;
};

export const getEcomInfo = (items: any, category?: any, location?: any) => {
  const itemData: any = [];
  items?.map((item: any) => {
    if (item?.bundledOffers) {
      item?.bundledOffers?.map((cart: any) => {
        const itemCategory = category == '' ? item : category;
        itemData.push(getItemData(cart, { itemCategory, location }));
      });
    } else {
      itemData.push(getItemData(item, { location }));
    }
  });
  return itemData;
};

export const getEcomCartInfo = (items: any, category: any, location: any): ecomAddCartInfo => {
  const discontedPrice = items?.[0]?.derivedPrice?.[0]?.value;
  const ecomViewData: ecomAddCartInfo = {
    currency: CURRENCY,
    value: (discontedPrice && Number(discontedPrice)) ?? 0,
    items: getEcomInfo(items, category, location)
  };
  return ecomViewData;
};

export const trackEligibleItem = (
  type: string,
  prodData?: any,
  category?: any,
  location?: any
): void => {
  if (type === 'addtocart') {
    window.dataLayer.push({
      event: 'add_to_cart',
      event_name: 'add_to_cart',
      ecommerce: getEcomCartInfo(prodData, category, location),
      transaction_type: prodData?.[0]?.isBundle ? 'BUNDLE' : 'MOBILE_ORDER'
    });
  }
};

//Function to track click event
export const clickEvent = (eventName: string, text: string) => {
  window.dataLayer.push({
    event: GAEVENT,
    event_name: eventName,
    click_text: text
  });
};

//Function to track toggle click
export const toggleEvent = (eventName: string, headline: string, selection: string) => {
  window.dataLayer.push({
    event: GAEVENT,
    event_name: eventName,
    headline: headline,
    selection: selection
  });
};
